import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {arraySwapItems, HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class ReorderPushableBlocksStore implements SaveStateHolder {
  @observable
  readonly pushableBlockIds: number[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly pageId: number,
              pushableBlockIds: number[]) {
    makeObservable(this);
    this.pushableBlockIds = pushableBlockIds.slice();
    this.save = null;
  }

  @action
  swap(index1: number, index2: number) {
    arraySwapItems(this.pushableBlockIds, index1, index2);
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    const reordered = this.pushableBlockIds.slice();
    this.save = contentLoaders.x6page.orderChildren(this.pageId, reordered);
  };
}
